import firebaseService from '../services/firebase.service';

/**
 * Use firebase currentUser. It will be null if the user isn't logged in OR if the initializeApp hasn't completed yet.
 *
 * Use onAuthStateChanged events to see if the user is logged in or not once the app initializes.
 */
export async function authGuard(to, from, next){
  const isLoggedIn = await new Promise((resolve, reject) => {
    if(firebaseService.currentUser){
      resolve(true);
    }else{
      firebaseService.once('onAuthStateChanged', (user) => {
        if(user){
          resolve(true);
        }else{
          resolve(false);
        }
      });
    }
  });
  if(isLoggedIn){
    console.log("authGuard: User is logged in");
    next();
  }else{
    console.log("authGuard: User is not logged in");
    next('/auth/login');
  }
}


// WEBPACK FOOTER //
// ./src/router/auth-guard.js